import { UrlLocationInput, UrlLocationSource } from '../interfaces/UrlLocation';

/**
 * Picks the location for the startup search from the URL params. The search only runs
 * with a location, so a campaign link that carries dates (or a discount code / acriss)
 * but no city falls back to Helsinki instead of landing on an empty page. An explicit
 * city or lat/lon always wins, and a location already in the session is never replaced.
 */
export function resolveUrlLocation(input: UrlLocationInput): UrlLocationSource {
    const { city, discount, acriss, urlLat, urlLon, hasUrlDates,
        savedLocation, savedDiscount, savedVehicleType, oneWay } = input;

    if (city) return 'city';
    if ((discount && !savedLocation && !savedDiscount)
        || (acriss && !savedLocation && !savedVehicleType)) {
        return 'helsinki';
    }
    if (urlLat && urlLon && !savedLocation && !oneWay) return 'latlon';
    if (hasUrlDates && !savedLocation && !oneWay) return 'helsinki';
    return 'keep';
}
